/// <reference types="react" />
import * as React from "react";

import { LinkedItemsGridViewActionsCreator } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Actions/LinkedItemsGridViewActionsCreator";
import { LinkedItemsGridViewActionsHub } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Actions/LinkedItemsGridViewActionsHub";
import { LinkedItemsGridView } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/ControllerViews/LinkedItemsGridView";
import { LinkedItemsGridViewSource } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Sources/LinkedItemsGridViewSource";
import { LinkedItemsGridViewStore } from "TestManagement/Scripts/Scenarios/LinkedItemsGridView/Stores/LinkedItemsGridViewStore";
import TCMContracts = require("TFS/TestManagement/Contracts");
import * as ComponentBase from "VSS/Flux/Component";
import { registerLWPComponent } from "VSS/LWP";


export interface ILegacyLinkedItemsGridViewProps extends ComponentBase.Props {
    testCaseResult: TCMContracts.TestCaseResult;
}

export class LegacyLinkedItemsGridView extends ComponentBase.Component<ILegacyLinkedItemsGridViewProps, {}> {

    constructor(props) {
        super(props);
        const linkedItemsGridViewActionsHub = new LinkedItemsGridViewActionsHub();
        const linkedItemsGridViewSource = new LinkedItemsGridViewSource();
        this._store = new LinkedItemsGridViewStore(linkedItemsGridViewActionsHub);
        this._actionCreator = new LinkedItemsGridViewActionsCreator(linkedItemsGridViewActionsHub, linkedItemsGridViewSource);
    }

    render() {
        return (
            <LinkedItemsGridView
                actionsCreator={this._actionCreator}
                store={this._store}
                {... this.props}
            />);
    }

    private _actionCreator: LinkedItemsGridViewActionsCreator;
    private _store: LinkedItemsGridViewStore;
}

registerLWPComponent("legacyLinkedItemsGridView", LegacyLinkedItemsGridView);